import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";

import { QueryConfig } from "../utils/query-config";
import { getV1OrganizationsInfoByOrganizationIdOptions } from "../../client/@tanstack/react-query.gen";

export const getOrganizationInfoOptions = (organizationId: string) =>
  queryOptions({
    ...getV1OrganizationsInfoByOrganizationIdOptions({
      path: { organizationID: organizationId },
    }),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

export const useGetOrganizationInfo = (organizationId: string) => {
  return useQuery({
    ...getOrganizationInfoOptions(organizationId),
  });
};
